export default __webpack_public_path__ + "static/media/utm-tag-management-template.e701b492.svg";